import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Logo from "../icon-img/UPES-logo.png"
const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);

  // Add a scroll event listener to make the navbar sticky
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <nav className={`navbar ${isSticky ? "sticky" : ""}`}>
      <div className="navbar-container">
        
        <Link className="navbar-brand" to="/">
          <img src={Logo} alt="UPES Logo" />
        </Link>

        {/* Toggler Button (for Mobile) */}
        <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
        <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navbar Links */}
        <ul className={`navbar-menu ${menuOpen ? "active" : ""}`}>
          <li><a href="#why-upes">Why UPES?</a></li>
          <li><a href="#Placements">Placements</a></li>
          <li><a href="#ProminentRecruiters">Prominent Recruiters</a></li>
          <li><a href="#programes">Programmes Offered</a></li>
          <li><a href="#admission">Admission Criteria</a></li>
          <li><a href="#partners">International Partners</a></li>
          <li><a href="#Achievements">Student Achievements</a></li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
